// ── Firebase Client SDK ──────────────────────────────────────────────────────
// The Admin SDK service account key (private_key) is SERVER-SIDE ONLY.
// Never use it in frontend code. This file uses the Web SDK (client-safe).
//
// Get your Web SDK config from:
//   Firebase Console → Project Settings → General → Your Apps → Web App
// Then add the values to .env.local

import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        'mimodocasal-17883.firebaseapp.com',
  projectId:         'mimodocasal-17883',
  storageBucket:     'mimodocasal-17883.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId:     import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const app       = initializeApp(firebaseConfig);
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
export const functions = getFunctions(app);

// Ambiente local de desenvolvimento roda contra o Firebase Emulator Suite por
// padrão (npm run dev), isolado do banco/auth/storage de produção. Para
// apontar propositalmente para produção durante o dev local, defina
// VITE_USE_FIREBASE_EMULATOR=false no .env.local.
if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATOR !== 'false') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}
